import { IonButton, IonCol, IonGrid, IonIcon, IonRow, IonSpinner, useIonToast } from '@ionic/react';
import { useParams, useHistory } from 'react-router';
import { useEffect, useState } from 'react';
import { print, arrowBack } from 'ionicons/icons';
import onPrint from '../../services/print.service';
import { fetchInvoice } from '../../services/account/invoice.service';
import InvoiceBody from '../../components/InvoiceBody';
import InvoiceEditModal from '../../components/Admin/InvoiceEditModal';
import { InvoiceContextProvider, useInvoiceContext, useInvoiceContextUpdater } from '../../services/invoice-context.service';
import AdminLayout from '../../layouts/AdminLayout';
import { appSubDir } from '../../configs/app';
import './AdminPages.scss';

const Body: React.FC = () => {
    const { invoiceID } = useParams() as any;
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);
    const invoice = useInvoiceContext();
    const setInvoice = useInvoiceContextUpdater();
    const [presentToast] = useIonToast();

    useEffect(() => {
        setIsLoading(true);
        fetchInvoice(invoiceID)
            .then(setInvoice)
            .catch((errPromise) => {
                errPromise.then((errResponse: any) => {
                    const messages = [];
                    if (errResponse.message && Object.values(errResponse.message).length > 0) {
                        messages.push(
                            Object.values(errResponse.message)
                                .map((item) => {
                                    const temp = item as string[];
                                    return temp.join(',');
                                })
                                .join(',')
                        );
                    } else if (errResponse.message) {
                        messages.push(errResponse.message);
                    } else {
                        messages.push('Something Went Wrong');
                    }
                    presentToast({
                        message: messages.join(','),
                        duration: 3000,
                        cssClass: 'custom-toast',
                        animated: true,
                        color: 'danger',
                        buttons: [
                            {
                                text: 'Dismiss',
                                role: 'cancel',
                            },
                        ],
                    });
                });
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [invoiceID]);

    return (
        <IonGrid>
            <IonRow>
                <IonCol size="12">
                    <div style={{ textAlign: 'center' }} className="print-hidden">
                        {isLoading ? (
                            <IonSpinner style={{ marginTop: 50, marginBottom: 50 }} />
                        ) : (
                            <>
                                {invoice ? (
                                    <>
                                        <div style={{ marginBottom: 20, display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                            <IonButton onClick={() => history.push(appSubDir + 'admin/orders')} fill="outline">
                                                <IonIcon icon={arrowBack} slot="start" />
                                                Back to Orders
                                            </IonButton>
                                            <IonButton onClick={onPrint} color="secondary">
                                                <IonIcon icon={print} slot="start" />
                                                Print
                                            </IonButton>
                                            <InvoiceEditModal />
                                        </div>
                                    </>
                                ) : (
                                    <div className="admin-card" style={{ textAlign: 'center', padding: '50px' }}>
                                        <h2>Order Not Found</h2>
                                        <IonButton onClick={() => history.push(appSubDir + 'admin/orders')} fill="outline" style={{ marginTop: 20 }}>
                                            <IonIcon icon={arrowBack} slot="start" />
                                            Back to Orders
                                        </IonButton>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    {!isLoading && invoice && (
                        <div className="print-section" style={{ background: 'white', padding: '20px', borderRadius: '8px' }}>
                            <InvoiceBody />
                        </div>
                    )}
                </IonCol>
            </IonRow>
        </IonGrid>
    );
};

const AdminOrderDetailPage: React.FC = () => {
    const { invoiceID } = useParams() as any;

    return (
        <AdminLayout title={`Order #${invoiceID}`}>
            <InvoiceContextProvider>
                <Body />
            </InvoiceContextProvider>
        </AdminLayout>
    );
};

export default AdminOrderDetailPage;
